export default __webpack_public_path__ + "static/media/linkedin.3503ef05.jpg";